import { mapState, mapGetters, mapActions } from "vuex";
import ConnectionPageTitle from "@/components/ConnectionPageTitle";
import AppCardConnections from "@/components/AppCardConnections";
import AppButton from "@/components/AppButton";
import AppIcon from "@/components/AppIcon";
import AppModal from "@/components/AppModal";
import CreateWorkspaceSideBar from "@/components/CreateWorkspaceSideBar";
import AppPagination from "@/components/AppPagination.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import { EVENTS } from "@/utils";
export default {
  name: "AllWorkspacesPage",
  mixins: [TasksMixin],
  components: {
    ConnectionPageTitle,
    AppCardConnections,
    AppButton,
    AppIcon,
    AppModal,
    CreateWorkspaceSideBar,
    AppPagination
  },
  data() {
    return {
      dataLoading: true,
      currentLoading: false,
      removeLoading: false,
      searchPlaceHolder: "Search",
      workspaceRemoveTaskIdentifier: "",
      page: 1,
      perPage: 20,
      confirmRemoveModal: false,
      removeId: null,
      currentId: null,
      createWorkspaceSideBar: false
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      workspaces: state => state.workspace.list,
      current_workspace: state => state.workspace.current_workspace,
      isOmnyAdmin: state => state.auth.isOmnyAdmin
    }),
    ...mapGetters(["accountByWorkspaceIdGet", "accountAdvertisingBySellerIdGet"]),
    // isLoggedIn() {
    //   return !! this.token
    // },

    formatDate() {
      return date => {
        // Date formatting
        return date;
      };
    },
    totalPages() {
      return this.$store.getters.workspaceGetTotalPages();
    },
    paginatedWorkspaces() {
      const startIndex = (this.page - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      return this.workspaces.slice(startIndex, endIndex);
    }
  },
  async mounted() {
    var is_authenticated = await this.authStatus();
    if (is_authenticated) {
      await this.refreshWorkspaceList();
      this.dataLoading = false;
      window.$bus.on("refreshWorkspaceList", this.refreshWorkspaceList);
      this.checkIfAnyPreviousWorskpaceRemoveTaskIsRunning();
    }
  },
  created() {
    this.checkAutoOpenModal();
  },
  methods: {
    ...mapActions(["workspaceList", "workspaceCurrent", "workspaceChange", "workspaceRemove", "contentDelete", "accountRemove", "authStatus"]),
    async onCurrentChange(workspace_id) {
      this.currentId = workspace_id;
      this.currentLoading = true;
      await this.workspaceChange({
        workspace_id: this.currentId
      });
      window.$bus.trigger(EVENTS.REFRESH_APPLICATION);
      this.currentLoading = false;
      this.currentId = null;
      //this.$router.push(`/`);
    },
    isCurrent(workspace) {
      return workspace.workspace_id == this.current_workspace.workspace_id;
    },
    isOmnyWorkspace(workspace) {
      return workspace.workspace_name == "All Accounts";
    },
    onMembers(workspace_id) {
      this.$router.push(`/manage-accounts/${workspace_id}/members`);
    },
    onRemove(workspace_id) {
      this.removeId = workspace_id;
      this.confirmRemoveModal = true;
    },
    handleIdle() {
      this.removeLoading = false;
    },
    handleFailed() {
      this.removeLoading = false;
    },
    handleRunning(data) {
      this.removeLoading = true;
      this.checkTaskStatusPeriodically(data?.task_id);
    },
    handleFinished(data) {
      this.removeLoading = false;
      this.removeId = null;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      ;
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: "Your Workspace has been deleted",
        delay: 60 // Show alert less than 1 minute
      });
      this.refreshWorkspaceList();
    },
    checkIfAnyPreviousWorskpaceRemoveTaskIsRunning() {
      for (const workspace in this.workspaces) {
        this.removeId = workspace.account_id;
        this.workspaceRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + this.removeId + "_" + "workspaces_delete";
        this.getAsyncUpdate(this.workspaceRemoveTaskIdentifier);
        this.checkTaskStatusPeriodically(this.workspaceRemoveTaskIdentifier);
        for (const account in this.accountByWorkspaceIdGet(this.removeId)) {
          this.removeId = account.account_id;
          this.workspaceRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + this.removeId + "_" + "workspaces_delete";
          this.getAsyncUpdate(this.workspaceRemoveTaskIdentifier);
          this.checkTaskStatusPeriodically(this.workspaceRemoveTaskIdentifier);
        }
      }
      ;
    },
    async onRemoveConfirm() {
      this.confirmRemoveModal = false;
      this.removeLoading = true;

      //delete all content and accounts related to a workspace
      let seller_list = this.accountByWorkspaceIdGet(this.removeId);
      this.workspaceRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + this.removeId + "_" + "workspaces_delete";
      let workspace_remove_task = await this.workspaceRemove({
        workspace_id: this.removeId,
        seller_list: seller_list,
        task_identifier_omny: this.workspaceRemoveTaskIdentifier
      });
      this.getAsyncUpdate(workspace_remove_task.task_id);
      this.checkTaskStatusPeriodically(workspace_remove_task.task_id);
    },
    async refreshWorkspaceList() {
      await this.workspaceList();
      await this.workspaceCurrent();
    },
    updatePerPage(perPage) {
      this.page = 1;
      this.perPage = perPage;
    },
    checkAutoOpenModal() {
      if (this.$route.query.openModal === "addAccountFromTop") {
        this.createWorkspaceSideBar = true;
      }
    }
  }
};